<template>
  <div>
    <el-menu class="el-menu-demo" mode="horizontal">
      <el-select v-model="dwid" filterable placeholder="请选择单位信息" @change="queryAllck()">
        <el-option v-for="item in options" :key="item.DWID" :label="item.DWNAME" :value="item.DWID">
        </el-option>
      </el-select>

      <el-select v-model="kczzcode" filterable placeholder="请选择库存组织">
        <el-option v-for="item in kczzs" :key="item.code" :label="item.name" :value="item.code">
        </el-option>
      </el-select>

      <el-select v-model="ckcode" filterable placeholder="请选择仓库信息">
        <el-option v-for="item in cks" :key="item.code" :label="item.name" :value="item.code">
        </el-option>
      </el-select>

      <el-button @click="dialogTableVisible = true">购物车🛒({{ gwc.length }})</el-button>
    </el-menu>

    <el-form :inline="true" :model="queryForm" class="demo-form-inline">

      <el-form-item label="存货名称">
        <el-input v-model="queryForm.chname" placeholder="请输入存货名称"></el-input>
      </el-form-item>

      <el-form-item label="存货编码">
        <el-input v-model="queryForm.chcode" placeholder="请输入存货编码"></el-input>
      </el-form-item>

      <el-form-item label="规格">
        <el-input v-model="queryForm.guige" placeholder="请输入规格"></el-input>
      </el-form-item>

      <el-form-item label="型号">
        <el-input v-model="queryForm.xinghao" placeholder="请输入型号"></el-input>
      </el-form-item>

      <el-form-item label="助记码">
        <el-input v-model="queryForm.zhujima" placeholder="请输入助记码"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="queryButton()">查询({{ tableData.length }}条)</el-button>
        <el-button type="primary" @click="buttonclick()">生成</el-button>
        <el-button type="primary" @click="buttonReset()">重置</el-button>
      </el-form-item>

    </el-form>

    <el-table stripe :data="tableData" ref="multipleTable" tooltip-effect="dark" style="width: 100%" height="80vh"
      @selection-change="handleSelectionChange" v-loading="loading" element-loading-text="拼命加载中">
      <el-table-column type="selection" width="55">
      </el-table-column>
      <el-table-column type="index" width="55">
      </el-table-column>
      <el-table-column prop="KCZZNAME" label="库存组织" width="120" sortable>
      </el-table-column>
      <el-table-column prop="CKNAME" label="仓库名称" width="120" sortable>
      </el-table-column>
      <el-table-column prop="CHCODE" label="存货编码" width="120" sortable>
      </el-table-column>
      <el-table-column prop="CHNAME" label="存货名称" width="120" sortable>
      </el-table-column>
      <!-- <el-table-column prop="PINPAI" label="品牌" width="120">
      </el-table-column> -->
      <el-table-column prop="GUIGE" label="规格" width="120" sortable>
      </el-table-column>
      <el-table-column prop="XINGHAO" label="型号" width="120" sortable>
      </el-table-column>
      <el-table-column prop="JLDW" label="计量单位" width="120" sortable>
      </el-table-column>
      <el-table-column prop="ZJM" label="助记码" width="300" show-overflow-tooltip sortable>
      </el-table-column>
      <el-table-column label="操作"  show-overflow-tooltip >
        <template slot-scope="{ row }">
          <el-button @click="addgwc(row)">加入购物车➕</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- <el-pagination @size-change="sizeChange" @current-change="currentChaneg" :current-page="page" :page-size="size"
      :page-sizes="pageSizes" layout="total,sizes,prev,pager,next,jumper" :total="total"></el-pagination> -->

    <el-drawer title="二维码生成" :visible.sync="drawer" direction="ltr" :before-close="handleClose" size="85%">
      <el-button @click="downloadImageGridAsPDF()">下载</el-button>
      <div class="image-grid">
        <!-- 使用 v-for 指令遍历 urls 数组 -->
        <div v-for="(url, index) in urls" :key="index" class="image-item">
          <img :src="url" alt="图片" />
        </div>
      </div>
    </el-drawer>

    <el-dialog width="80%" :visible.sync="dialogTableVisible">
      <el-button type="danger" @click="clearGWC">清空购物车</el-button>
      <el-button @click="buttonclick2">生成</el-button>
      <el-table @selection-change="handleSelectionChange2" ref="multipleTable2" :data="gwc">
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column type="index" width="55">
        </el-table-column>
        <el-table-column prop="KCZZNAME" label="库存组织" width="120" sortable>
        </el-table-column>
        <el-table-column prop="CKNAME" label="仓库名称" width="120" sortable>
        </el-table-column>
        <el-table-column prop="CHCODE" label="存货编码" width="120" sortable>
        </el-table-column>
        <el-table-column prop="CHNAME" label="存货名称" width="120" sortable>
        </el-table-column>
        <!-- <el-table-column prop="PINPAI" label="品牌" width="120">
      </el-table-column> -->
        <el-table-column prop="GUIGE" label="规格" width="120" sortable>
        </el-table-column>
        <el-table-column prop="XINGHAO" label="型号" width="120" sortable>
        </el-table-column>
        <el-table-column prop="JLDW" label="计量单位" width="120" sortable>
        </el-table-column>
        <el-table-column prop="ZJM" label="助记码" show-overflow-tooltip sortable>
        </el-table-column>
      </el-table>
    </el-dialog>

  </div>
</template>
<script>
import { getalldw, queryck, querykczz, getinforxcl, getCaoliao } from '../api/index.js'
import html2canvas from "html2canvas";
import { Loading } from 'element-ui';
import jsPDF from "jspdf";
export default {
  data() {
    return {
      multipleTable2:[],
      dialogTableVisible: false,
      gwc: [],
      drawer: false,
      dwid: "",
      options: [],
      kczzs: [],
      kczzcode: "",
      cks: [],
      ckcode: "",
      queryForm: {
        chname: "",
        chcode: "",
        guige: "",
        xinghao: "",
        zhujima: ""
      },
      tableData: [],
      // tableData2: [],
      multipleTable: [],
      urls: [],
      loading: false
    }
  },
  methods: {
    //清空购物车
    clearGWC(){
      this.gwc = []
    },
    //添加购物车
    addgwc(item){
      this.gwc.push(item)
      this.$message({
          showClose: true,
          message: '加入购物车成功！',
          type: 'success'
        });
    },
    //下载pdf
    downloadImageGridAsPDF() {
      const imageGrid = document.querySelector(".image-grid");
      if (!imageGrid) {
        console.error("无法找到 .image-grid 容器");
        return;
      }

      // 获取所有图片元素
      const images = Array.from(imageGrid.querySelectorAll("img"));

      const pdf = new jsPDF("p", "mm", "a4"); // 创建纵向 A4 尺寸的 PDF
      const pageWidth = 210; // A4宽度
      const pageHeight = 297; // A4高度
      const imagesPerPage = 14; // 每页显示的图片数（修改为14）
      const margin = 10; // 页面边距
      const gap = 2; // 图片之间的间距
      const borderWidth = 0.5; // 边框宽度（毫米）

      let currentPage = 1;

      for (let i = 0; i < images.length; i++) {
        if (i % imagesPerPage === 0 && i !== 0) {
          // 如果当前图片是每页的第一个，则添加新页
          pdf.addPage();
          currentPage++;
        }

        // 计算当前图片在页面中的位置
        const row = Math.floor((i % imagesPerPage) / 2); // 每行两个图片
        const col = (i % imagesPerPage) % 2;
        const x = margin + col * ((pageWidth - 2 * margin - gap) / 2); // 左边距加列宽和间距
        const y = margin + row * ((pageHeight - 2 * margin - gap * 6) / 7); // 上边距加行高和间距（调整为7行）

        // 动态获取图片的原始尺寸
        const img = images[i];
        const imgWidth = img.naturalWidth;
        const imgHeight = img.naturalHeight;

        // 根据图片的宽高比调整图片的尺寸，确保适应页面布局
        const maxWidth = (pageWidth - 2 * margin - gap) / 2; // 最大宽度 
        const maxHeight = (pageHeight - 2 * margin - gap * 6) / 7; // 最大高度（调整为7行）
        let scaledWidth = imgWidth;
        let scaledHeight = imgHeight;

        // 如果图片宽度超出最大宽度，则按比例缩放
        if (scaledWidth > maxWidth) {
          const ratio = maxWidth / scaledWidth;
          scaledWidth *= ratio;
          scaledHeight *= ratio;
        }

        // 如果图片高度超出最大高度，则再次按比例缩放
        if (scaledHeight > maxHeight) {
          const ratio = maxHeight / scaledHeight;
          scaledWidth *= ratio;
          scaledHeight *= ratio;
        }

        // 添加图片到 PDF 页面
        pdf.addImage(img.src, "PNG", x, y, scaledWidth, scaledHeight);

        // // 绘制图片外边框
        // pdf.setLineWidth(borderWidth); // 设置边框线宽
        // pdf.setDrawColor(0); // 设置边框颜色为黑色
        // pdf.rect(x - borderWidth / 2, y - borderWidth / 2, scaledWidth + borderWidth, scaledHeight + borderWidth); // 绘制矩形边框
        // 绘制分割线（仅在第一列时绘制，避免重复）
        // if (col === 0) {
        const rowTopY = y; // 当前行顶部 Y 坐标
        const rowBottomY = y + maxHeight; // 当前行底部 Y 坐标

        // 绘制行顶部分割线
        pdf.setLineWidth(0.2); // 设置分割线宽度
        pdf.setDrawColor(0); // 设置分割线颜色为灰色
        pdf.line(margin, rowTopY, pageWidth - margin, rowTopY); // 从左到右绘制分割线

        // 绘制行底部分割线
        // pdf.line(margin, rowBottomY, pageWidth - margin, rowBottomY); // 从左到右绘制分割线
        // }
      }

      pdf.save("image-grid.pdf");
    },
    // downloadImageGridAsPDF() {
    //   const imageGrid = document.querySelector(".image-grid");

    //   if (!imageGrid) {
    //     console.error("无法找到 .image-grid 容器");
    //     return;
    //   }

    //   // 获取所有图片元素
    //   const images = Array.from(imageGrid.querySelectorAll("img"));

    //   const pdf = new jsPDF("p", "mm", "a4"); // 创建纵向 A4 尺寸的 PDF
    //   const pageWidth = 210; // A4宽度
    //   const pageHeight = 297; // A4高度
    //   const imagesPerPage = 10; // 每页显示的图片数
    //   const margin = 10; // 页面边距
    //   const gap = 5; // 图片之间的间距

    //   let currentPage = 1;

    //   for (let i = 0; i < images.length; i++) {
    //     if (i % imagesPerPage === 0 && i !== 0) {
    //       // 如果当前图片是每页的第一个，则添加新页
    //       pdf.addPage();
    //       currentPage++;
    //     }

    //     // 计算当前图片在页面中的位置
    //     const row = Math.floor((i % imagesPerPage) / 2); // 每行两个图片
    //     const col = (i % imagesPerPage) % 2;
    //     const x = margin + col * ((pageWidth - 2 * margin - gap) / 2); // 左边距加列宽和间距
    //     const y = margin + row * ((pageHeight - 2 * margin - gap * 4) / 5); // 上边距加行高和间距

    //     // 动态获取图片的原始尺寸
    //     const img = images[i];
    //     const imgWidth = img.naturalWidth;
    //     const imgHeight = img.naturalHeight;

    //     // 根据图片的宽高比调整图片的尺寸，确保适应页面布局
    //     const maxWidth = (pageWidth - 2 * margin - gap) / 2; // 最大宽度
    //     const maxHeight = (pageHeight - 2 * margin - gap * 4) / 5; // 最大高度
    //     let scaledWidth = imgWidth;
    //     let scaledHeight = imgHeight;

    //     // 如果图片宽度超出最大宽度，则按比例缩放
    //     if (scaledWidth > maxWidth) {
    //       const ratio = maxWidth / scaledWidth;
    //       scaledWidth *= ratio;
    //       scaledHeight *= ratio;
    //     }

    //     // 如果图片高度超出最大高度，则再次按比例缩放
    //     if (scaledHeight > maxHeight) {
    //       const ratio = maxHeight / scaledHeight;
    //       scaledWidth *= ratio;
    //       scaledHeight *= ratio;
    //     }

    //     // 添加图片到 PDF 页面
    //     pdf.addImage(img.src, "PNG", x, y, scaledWidth, scaledHeight);

    //   }

    //   pdf.save("image-grid.pdf");
    // },


    //关闭侧边栏
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
          this.urls = []
        })
        .catch(_ => { });
    },
    //重置表单
    buttonReset() {
      this.dwid = ""
      this.kczzcode = ""
      this.ckcode = ""
      this.queryForm = {
        chname: "",
        chcode: "",
        guige: "",
        xinghao: ""
      }
      this.tableData = []
    },
    //获得选中信息
    handleSelectionChange(selection) {
      this.multipleTable = selection
    },
    //购物车获得选中信息
    handleSelectionChange2(selection) {
      this.multipleTable2 = selection
    },
    //选中生成
    buttonclick() {
      if (this.multipleTable.length === 0) {
        this.$message.warning('请先选择需要生成的数据');
        return false;
      }
      // console.log("选中的数据：", this.multipleTable);
      for (let i = 0; i < this.multipleTable.length; i++) {
        // console.log(this.cwUrlarray[i])
        let clid = this.multipleTable[i].CHCODE + '%2B' + this.multipleTable[i].KCZZ + '%2B' + this.multipleTable[i].KCZZNAME + '%2B' + this.multipleTable[i].CK + '%2B' + this.multipleTable[i].CKNAME
        // console.log(clid)
        let encodedClid = encodeURIComponent(clid);
        // let clif1 = "存货编码:" + this.multipleTable[i].CHCODE
        // let clif2 = "存货名称:" + this.multipleTable[i].CHNAME
        // let clif3 = "规格型号:" + this.multipleTable[i].GUIGE
        // let clif4 = "计量单位:" + this.multipleTable[i].JLDW
        // let clif5 = "助记码:" + this.multipleTable[i].ZJM

        let clif1 = encodeURIComponent("存货编码:" + this.multipleTable[i].CHCODE);
        let clif2 = encodeURIComponent("存货名称:" + this.multipleTable[i].CHNAME);
        let clif3 = encodeURIComponent("规格型号:" + this.multipleTable[i].GUIGE);
        let clif4 = encodeURIComponent("计量单位:" + this.multipleTable[i].JLDW);
        let clif5 = encodeURIComponent("助记码:" + this.multipleTable[i].ZJM);

        // console.log(clid)
        // this.getEwm(clid, clif1, clif2, clif3, clif4)
        this.url = []
        getCaoliao(encodedClid, clif1, clif2, clif3, clif4, clif5).then(res => {
          // console.log(res)
          this.urls.push(res)
          this.drawer = true
        }).catch(res => {
          this.$message.warning('草料二维码端口出错');
        })
      }
    },
    //购物车选中生成
    buttonclick2() {
      if (this.multipleTable2.length === 0) {
        this.$message.warning('请先选择需要生成的数据');
        return false;
      }
      // console.log("选中的数据：", this.multipleTable);
      for (let i = 0; i < this.multipleTable2.length; i++) {
        // console.log(this.cwUrlarray[i])
        let clid = this.multipleTable2[i].CHCODE + '%2B' + this.multipleTable2[i].KCZZ + '%2B' + this.multipleTable2[i].KCZZNAME + '%2B' + this.multipleTable2[i].CK + '%2B' + this.multipleTable2[i].CKNAME
        // console.log(clid)
        let encodedClid = encodeURIComponent(clid);


        let clif1 = encodeURIComponent("存货编码:" + this.multipleTable2[i].CHCODE);
        let clif2 = encodeURIComponent("存货名称:" + this.multipleTable2[i].CHNAME);
        let clif3 = encodeURIComponent("规格型号:" + this.multipleTable2[i].GUIGE);
        let clif4 = encodeURIComponent("计量单位:" + this.multipleTable2[i].JLDW);
        let clif5 = encodeURIComponent("助记码:" + this.multipleTable2[i].ZJM);

        // console.log(clid)
        // this.getEwm(clid, clif1, clif2, clif3, clif4)
        this.url = []
        getCaoliao(encodedClid, clif1, clif2, clif3, clif4, clif5).then(res => {
          // console.log(res)
          this.urls.push(res)
          this.dialogTableVisible = false
          this.drawer = true
        }).catch(res => {
          this.$message.warning('草料二维码端口出错');
        })
      }
    },
    //查询按钮
    queryButton() {
      this.tableData = []
      if (this.dwid == "" || this.kczzcode == "" || this.ckcode == "") {
        this.$message.warning('请选择完整的单位信息、库存组织信息、仓库信息');
        return false
      }
      this.loading = true
      getinforxcl(this.dwid, this.kczzcode, this.ckcode, this.queryForm.chname, this.queryForm.chcode, this.queryForm.guige, this.queryForm.xinghao, this.queryForm.zhujima).then(res => {
        // console.log(res);
        this.tableData = res//所有数据
        this.loading = false
      }).catch(res => {
        this.loading = false
        this.$message.warning('查询错误请检查查询条件');
      })
    },
    // //page改变时的回调函数，参数为当前页码
    // currentChange(val) {
    //   console.log("翻页，当前为第几页", val);
    //   this.page = val;
    //   this.getTabelData2();
    // },
    // //size改变时回调的函数，参数为当前的size
    // sizeChange(val) {
    //   console.log("改变每页多少条，当前一页多少条数据", val);
    //   this.size = val;
    //   this.page = 1; 
    //   this.getTabelData2();
    // },
    //获得所有单位
    getSYDW() {
      getalldw().then(res => {
        this.options = res
      });
    },
    //获取该单位库存组织
    getKCzz() {
      this.kczzcode = ""
      querykczz(this.dwid).then(res => {
        // console.log(res)
        this.kczzs = res
      })
    },
    //获得所选单位所有仓库
    queryAllck() {
      this.ckcode = ""
      queryck(this.dwid).then(res => {
        this.cks = res
      })
      this.getKCzz()
    },

  },
  mounted() {
    this.getSYDW()
  }
}
</script>
<style>
/* 使用 CSS Grid 布局 */
.image-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  /* 每行三列 */
  gap: 10px;
  /* 图片之间的间距 */
}

.image-item {
  /* 设置图片大小等样式 */
}

.image-item img {
  width: 100%;
  height: auto;
  display: block;
}
</style>
